<template>
<div>
  <div class="home" v-if="pcShow">
    <headerTitle indexInit="5"/>
    <carouselPics :pics="pics" carouselIndex="1"/>
    <div class="block_div"></div>
    <!-- <videoBlock :videoArray="videoArray" @selectPics="selectPics"/> -->
    <videoBlockSelectOdd :videoArray="videoArraySelect" @selectPics="selectPics"/>
    <div class="block_div"></div>
    <footerBlock />
    <videoEachBlock @closeVideoFn="closeVideoFn" :videoUrl="videoUrl" v-if="videoFlag"/>
  </div>
  <div v-if="!pcShow" class="mobile_videocourse">
      <mobileHeader indexInit="5"/>
      <mobileCarousel :pics="images" carouselIndex="1"/>
      <mobileDivBlock />
      

<!-- 

      <mobileTitleBlock textChinese="服务优势" textEnglish="SERVICE  ADVANCED"/>
    <mobileDivBlock />
    <mobileserviceAdvancedTextThree />
    <mobileDivBlock />
    


    <mobileTitleBlock textChinese="服务项目" textEnglish="SERVICE  PROJECT"/>
    <mobileDivBlock />
    <mobileserviceProject/>

    <mobileDivBlock />
     <mobileTitleBlock textChinese="知识达人" textEnglish="KNOWLEDGE  TALENT"/>
     <mobileDivBlock />
     <mobileknowledgeTalent />

     <mobileDivBlock />-->
    <mobilevideoBlockSelectOdd :videoArray="videoArraySelect" @selectPics="selectPics"/>

    <mobileDivBlock /> 


<mobilefooterBlock />
<videoEachBlock @closeVideoFn="closeVideoFn" :videoUrl="videoUrl" v-if="videoFlag"/>
  </div>
  </div>
</template>

<script>
// @ is an alias to /src
import carouselPics from '@/components/carouselPics.vue'
import headerTitle from '@/components/headerTitle.vue'
import titleBlock from '@/components/titleBlock.vue'
import serviceBlock from '@/components/serviceBlock.vue'
import videoBlock from '@/components/videoBlock.vue'
import videoBlockSelectOdd from '@/components/videoBlockSelectOdd.vue'
import serviceProgress from '@/components/serviceProgress.vue'
import serviceClient from '@/components/serviceClient.vue'
import footerBlock from '@/components/footerBlock.vue'
import serviceAdvanced from '@/components/serviceAdvanced.vue'
import videoEachBlock from '@/components/videoEachBlock.vue'
import mobileHeader from "@/components/mobileHeader.vue";
import mobileCarousel from "@/components/mobileCarousel.vue";
import mobileDivBlock from "@/components/mobileDivBlock.vue";
import mobilefooterBlock from "@/components/mobilefooterBlock.vue";
import mobilevideoBlockSelectOdd from "@/components/mobilevideoBlockSelectOdd.vue";




export default {
  name: 'Home',
  data() {
    return {
      pics:[
        {url:require('@/assets/imgs/banner601.jpeg'),linerow:7,style:'margin-left:-200px;text-align:right',text:'<span style="font-size:54px;color:#fff">科技引领，</span><span style="font-size:62px;color:#e91d62">视觉当先</span>'},
        // {url:require('@/assets/imgs/banner02.jpeg'),text:'你好'},
        // {url:require('@/assets/imgs/banner03.jpeg'),text:'你好'},
        // {url:require('@/assets/imgs/banner04.jpeg'),text:'你好'}
      ],
      videoUrl:{},
      videoFlag:false,
      videoArray:[ 
        [{url:require('@/assets/video/video601.jpg'),text:'箭牌Arrow发布会',videoUrl:require('@/assets/video/video601.mp4')},
        {url:require('@/assets/video/video602.jpg'),text:'产城之梦四折幕三维',videoUrl:require('@/assets/video/video602.mp4')}],
        [{url:require('@/assets/video/video603.jpg'),text:'中国电信裸眼3D',videoUrl:require('@/assets/video/video603.mp4')},
        {url:require('@/assets/video/video604.jpg'),text:'国家地震局球幕专题片',videoUrl:require('@/assets/video/video604.mp4')}],
        [{url:require('@/assets/video/video605.jpg'),text:'惠普暗影精灵笔记本发布会异形屏',videoUrl:require('@/assets/video/video605.mp4')},
        {url:require('@/assets/video/video606.jpg'),text:'北京世界公园大战外星人夜游投影',videoUrl:require('@/assets/video/video606.mp4')}],
        [{url:require('@/assets/video/video607.jpg'),text:'浙江密赛山崖激光秀',videoUrl:require('@/assets/video/video607.mp4')},
        {url:require('@/assets/video/video608.jpg'),text:'徐州未来智慧城市网络沙盘',videoUrl:require('@/assets/video/video608.mp4')}],
        
      ],
      videoArraySelect:[ 
        {url:require('@/assets/video/video601.jpg'),text:'箭牌Arrow发布会',videoUrl:require('@/assets/video/video601.mp4')},
        {url:require('@/assets/video/video602.jpg'),text:'产城之梦四折幕三维',videoUrl:require('@/assets/video/video602.mp4')},
        {url:require('@/assets/video/video603.jpg'),text:'国家地震局球幕专题片',videoUrl:require('@/assets/video/video603.mp4')},
        {url:require('@/assets/video/video604.jpg'),text:'徐州未来智慧城市网络沙盘',videoUrl:require('@/assets/video/video604.mp4')},
        {url:require('@/assets/video/video605.jpg'),text:'浙江密赛山崖激光秀',videoUrl:require('@/assets/video/video605.mp4')},
        {url:require('@/assets/video/video606.jpg'),text:'中国电信裸眼3D',videoUrl:require('@/assets/video/video606.mp4')},
        {url:require('@/assets/video/video607.jpg'),text:'北京世界公园大战外星人夜游投影',videoUrl:require('@/assets/video/video607.mp4')},
        {url:require('@/assets/video/video608.jpg'),text:'惠普暗影精灵笔记本发布会异形屏',videoUrl:require('@/assets/video/video608.mp4')},
        
      ],
      pcShow: true,
      images: [
        {url:require('@/assets/imgs/banner601.jpeg'),linerow:7,style:'margin-left:-200px;text-align:right',text:'<span style="font-size:16px;color:#fff">科技引领，</span><span style="font-size:16px;color:#e91d62">视觉当先</span>'},
      ]
    }
  },
  components: {
    carouselPics,
    headerTitle,
    titleBlock,
    serviceBlock,
    videoBlock,
    serviceProgress,
    serviceClient,
    footerBlock,
    serviceAdvanced,
    videoEachBlock,
    videoBlockSelectOdd,
    mobileHeader,
    mobileCarousel,
    mobileDivBlock,
    mobilefooterBlock,
    mobilevideoBlockSelectOdd
  },
  mounted() {
    this.widthChange();
    window.addEventListener("resize", this.widthChange);
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
  methods:{
    widthChange() {
      console.log(123333);
      let clientWidthW = document.body.clientWidth;
      console.log(this.pcShow, "999000this.pcShow");
      console.log(clientWidthW, "9900");
      if (clientWidthW < 768) {
        this.pcShow = false;
      } else {
        this.pcShow = true;
      }
    },
    closeVideoFn(){
      this.videoFlag = false
    },
    selectPics(item){
      this.videoFlag = true
      this.videoUrl.videoUrl = item.videoUrl
      // this.videoUrl.videoUrl = this.videoArray[index][inx].videoUrl
      console.log(this.videoUrl,'this.videoUrl')
    }
  },
}
</script>
<style lang="less">

</style>
